
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import CookieBanner from '@/CookieBanner.vue'
import Header from '@/Header.vue'
import Notice from '@/Notice.vue'
import SuccessConfirmation from '@/components/SuccessConfirmation.vue'
import ErrorSummary from '@/components/ErrorSummary.vue'
import Footer from '@/Footer.vue'

export default defineComponent(
{
   components:
   {
       CookieBanner,
       Header,
       Notice,
       SuccessConfirmation,
       ErrorSummary,
       Footer
   },
   setup()
   {
       // Load vuex:
       const store = useStore()

       // Computed state params:
       const showBackButton = computed(() =>
       {
           return store.getters['routing/showBackButton']
       })
       const backButtonRouteName = computed(() =>
       {
           return store.getters['routing/backButtonRouteName']
       })

       // Return data:
       return {
           showBackButton,
           backButtonRouteName
       }
   }
})
